<Dialog bind:value={showDialog} class="w-full md:w-1/2" {transitionProps}>
    <div slot="title" class="text-lg font-normal">Rea muutmine</div>
    <div class="w-full flex flex-wrap md:flex-nowrap">
        <div class="flex-grow md:mr-2">
            <Select
                    label="Kategooria"
                    items={cashEntryCategoriesOptions}
                    selectedLabel={cashEntry.categories.length && cashEntry.categories[0].title ? cashEntry.categories[0].title : 'Määramata'}
                    bind:showList={showList}
            >
                <div slot="options" class="overflow-y-auto absolute left-0 bg-white shadow rounded w-full z-20 max-h-72">
                    <List items={cashEntryCategoriesOptions} select>
                        <li slot="item" let:item={item}>
                            <div class="cursor-pointer p-4 my-2 hover:bg-gray-200" on:click={setCategory(item)}>
                                {item.text}
                            </div>
                        </li>
                    </List>
                </div>
            </Select>
        </div>
        <div class="flex-grow md:mr-2">
            <TextField label="Nimetus" bind:value={cashEntry.title}
                       error={ValidationUtils.createErrors($cashEntryForm, 'title')}/>
        </div>
        <div class="flex-grow">
            <TextField type="number" label="Summa" bind:value={cashEntry.amount}
                       error={ValidationUtils.createErrors($cashEntryForm, 'amount')}/>
        </div>
    </div>
    <div slot="actions">
        <Button color="secondary" on:click={() => showDialog = false}>Tühista</Button>
        {#if entry === null}
            <Button on:click={createCashEntry} disabled="{!$cashEntryForm.valid}">Salvesta</Button>
        {/if}
        {#if entry !== null}
            <Button on:click={updateCashEntry} disabled="{!$cashEntryForm.valid}">Salvesta</Button>
        {/if}
    </div>
</Dialog>

<script lang="ts">
  import {Dialog, Button, TextField, Select, Checkbox, List} from 'smelte';
  import ApiService from '../api-service';
  import type CashEntry from '../domain/cash-entry';
  import {createEventDispatcher, onMount} from 'svelte';
  import {snackbar, userInfo} from '../stores';
  import {quadIn} from 'svelte/easing';
  import {form} from 'svelte-forms';
  import ValidationUtils from '../utils/validation-utils';


  export let showDialog: boolean = false;
  export let entry: CashEntry = null;

  let cashEntry: CashEntry = {
    title: null,
    amount: null,
    categories: []
  };


  const transitionProps = {duration: 150, easing: quadIn, delay: 0};

  let showList = false;
  let cashEntryCategories: any[] = [];

  const cashEntryForm = form(() => ({
    title: {value: cashEntry.title, validators: ['required']},
    amount: {value: cashEntry.amount, validators: ['required', ValidationUtils.isNumber]}
  }));

  $: cashEntryCategoriesOptions = calculateCashEntryCategoriesOptions(cashEntryCategories);

  $: formErrors = {
    'title': ValidationUtils.createErrors($cashEntryForm, 'title'),
    'amount': ValidationUtils.createErrors($cashEntryForm, 'amount')
  };

  $: if (showDialog) {
    if (entry !== null) {
      cashEntry = entry;
    } else {
      cashEntry = {
        title: null,
        amount: null,
        categories: []
      };
    }
  }

  onMount(async () => {
    const response = await ApiService.getCashEntryCategoriesForUser($userInfo.id);
    cashEntryCategories = response.data;
    console.log('getching');
  });

  const dispatch = createEventDispatcher();

  async function createCashEntry() {
    const response = await ApiService.createCashEntry(cashEntry);
    showDialog = false;
    dispatch('create:cash-entry', response.data);
    snackbar.show('Uus rida lisatud');
  }

  async function updateCashEntry() {
    const response = await ApiService.updateCashEntry(cashEntry);
    showDialog = false;
    dispatch('update:cash-entry', response.data);
    snackbar.show('Muudatused salvestatud');
  }

  function calculateCashEntryCategoriesOptions(cashEntryCategories) {
    let categories = cashEntryCategories.map(c => {
      return {
        text: c.title,
        value: c
      };
    });

    categories = [{
      text: 'Määramata',
      value: undefined
    }, ...categories];

    return categories;
  }

  function setCategory(category) {
    if (category.text === 'Määramata') {
      cashEntry.categories = [];
    } else {
      cashEntry.categories = [category.value];
    }
    showList = false;
  }
</script>